module.exports = ".add-files-btn{float:right}.actions{justify-content:flex-end}.container{height:100%}\n"